import { Button, Col, Modal, Row } from "react-bootstrap";
import NFCeModalPropriedadesCode from "./NFCe.Modal.Propriedades.Code";
import { NFCeConsultaDto } from "../NFCe.Consulta.Dto";

interface Props {
  show: boolean;
  nfce: NFCeConsultaDto | undefined;
  onCancel: () => void;
  onDelete: (value: NFCeConsultaDto) => void;
  onPrint: (value: NFCeConsultaDto) => void;
  onDownloadXml: (value: NFCeConsultaDto) => void;
  onFetchStatus: (value: NFCeConsultaDto) => void;
}

const NFCeModalPropriedadesView = (props: Props) => {
  const { onCancelClick } = NFCeModalPropriedadesCode(
    props.onCancel,
    props.onPrint
  );

  const onDeleteHandler = () => {
    if (props.nfce) {
      props.onCancel();
      props.onDelete(props.nfce);
    }
  };

  const onPrintHandler = () => {
    if (props.nfce) {
      props.onPrint(props.nfce);
    }
  };

  const onDownloadXmlHandler = () => {
    if (props.nfce) {
      props.onDownloadXml(props.nfce);
    }
  };

  const onFetchStatusHandler = () => {
    if (props.nfce) {
      props.onFetchStatus(props.nfce);
    }
  };

  return (
    <>
      <Modal show={props.show} centered>
        <Modal.Body>
          <Row>
            <Col xs={6}>Número NFCe: {props.nfce?.numeroNF}</Col>
            <Col xs={6}>Serie: {props.nfce?.serie}</Col>
          </Row>
          <Row>
            <Col xs={12}>
              Status Envio: {props.nfce?.codigoStatusEnvio}-
              {props.nfce?.descricaoStatusEnvio}
            </Col>
          </Row>
          <Row>
            <Col xs={12}>
              Status Resposta: {props.nfce?.codigoStatusResposta}-
              {props.nfce?.descricaoMotivoResposta}
            </Col>
          </Row>
        </Modal.Body>
        <Modal.Footer>
          <Button
            variant="outline-primary"
            className="messagebox-btn-cancel"
            onClick={onCancelClick}
          >
            Cancelar
          </Button>
          <Button
            variant="outline-danger"
            className="messagebox-btn-cancel"
            onClick={onDeleteHandler}
          >
            Excluir
          </Button>
          <Button
            variant="outline-primary"
            className="messagebox-btn-cancel"
            onClick={onPrintHandler}
          >
            Imprimir
          </Button>
          <Button
            variant="outline-primary"
            className="messagebox-btn-cancel"
            onClick={onDownloadXmlHandler}
          >
            Baixar XML
          </Button>
          <Button
            variant="outline-primary"
            className="messagebox-btn-cancel"
            onClick={onFetchStatusHandler}
          >
            Consultar Situação
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default NFCeModalPropriedadesView;
